import { Injectable, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { ApiCallHandler } from './models/apiCallHandler';
import { IHttpParams } from 'ngx-eo-web-components';
import { STATUS } from './models/loading-status.enum';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  static injector: Injector;

  private subscriptions: Subscription[] = [];

  // private token$ = this.authService.token$;

  roles: string[] = [];
  useremail: string = '';

  constructor(
    private injector: Injector,
    private messageService: MessageService
  ) {
    CoreService.injector = this.injector;
    // this.subscriptions = [
    //   this.token$.subscribe((t) => {
    //     this.roles = t?.role?.split(',') ?? [];
    //     this.useremail = t?.email ?? '';
    //   }),
    // ];
    //this.authService.TokenExpirationCheck();
  }

  hasRoles(userRoles: string[]) {
    return userRoles.some((r) => this.roles.includes(r));
  }

  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any,
    options?: any
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any,
    options?: any
  ): IHttpParams {
    // apiCallHandler.status$.next(STATUS.loading);
    // apiCallHandler.error$.next(null);
    let result: IHttpParams = {
      ...{
        url: `${environment.apiUrl}${apiPath}`,
        success$: apiCallHandler.data$,
        status$: apiCallHandler.status$,
        error$: apiCallHandler.error$,
      },
      ...(requestBody != undefined && { body: requestBody }),
      options: { ...options },
    };

    return result;
  }

  successCall<T>(data: T, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.data$.next(data);
    apiCallHandler.status$.next(STATUS.success);
  }

  errorCall<T>(errorMessage: string, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.error$.next(errorMessage);
    apiCallHandler.status$.next(STATUS.error);
  }

  downLoadFile(data: any, type: string, filename: string) {
    try {
      // Create a Blob with the provided data
      const blob = new Blob([data], { type: type });

      // Log the blob size for debugging purposes
      console.log('Blob size:', blob.size);
      if (blob.size === 0) {
        console.warn(
          'The blob is empty. Check the server response or client-side handling.'
        );
        return;
      }

      // Create a temporary download link
      const downloadLink = document.createElement('a');
      const url = window.URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.setAttribute('download', filename);

      // Append the link to the document to make it clickable
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error while downloading file:', error);
    }
  }

  downLoadExcelFile(data: any, filename: string) {
    this.downLoadFile(
      data,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      filename
    );
  }

  showError(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Παρουσιάστηκε σφάλμα',
      detail: message,
    });
  }

  showSuccess(message: string, title: string = 'Επιτυχής ενέργεια') {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: message,
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((s) => s.unsubscribe);
  }
}
